import { render } from "./EditPortleTemplateViewTaskPopUp.vue?vue&type=template&id=2e5bd7a9&scoped=true"
import script from "./EditPortleTemplateViewTaskPopUp.vue?vue&type=script&lang=js"
export * from "./EditPortleTemplateViewTaskPopUp.vue?vue&type=script&lang=js"

import "./EditPortleTemplateViewTaskPopUp.vue?vue&type=style&index=0&id=2e5bd7a9&scoped=true&lang=css"
import "./EditPortleTemplateViewTaskPopUp.vue?vue&type=style&index=1&id=2e5bd7a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5bd7a9"]])

export default __exports__